<div class="product-details">
  <div class="top-section">
    <button class="btn btn-rg btn-light back-btn" (click)="goBack()">
      <ng-icon name="iconoirNavArrowLeft" size="20"></ng-icon>
      {{ dictionaryService.get('Back') }}
    </button>

    <div class="report-type-buttons">
      <button class="btn btn-rg btn-primary" [disabled]="isDownloadingComments()" (click)="downloadCommentsReport()">
        <ng-icon name="iconoirMultiBubble" size="20"></ng-icon>
        {{ isDownloadingComments() ? dictionaryService.get('Downloading') : dictionaryService.get('Comments') }}
      </button>
      <button class="btn btn-rg btn-primary" [disabled]="isDownloadingSFE()" (click)="downloadSFEReport()">
        <ng-icon name="iconoirHealthShield" size="20"></ng-icon>
        {{ isDownloadingSFE() ? dictionaryService.get('Downloading') : dictionaryService.get('SFE') }}
      </button>
    </div>
  </div>

  <app-tabs>
    <app-versions-calls-charts-tab [productId]="productId()"></app-versions-calls-charts-tab>
    <app-reps-calls-charts-tab [productId]="productId()"></app-reps-calls-charts-tab>
    <app-calls-durations-tab [productId]="productId()"></app-calls-durations-tab>
  </app-tabs>
</div>